var divider_viewer_default = {
  "divider-container": "OIK57",
  "divider-container--double": "OE5yz",
  "divider": "_1-oaE",
  "divider--single": "QEYy1",
  "divider--double": "_2IoCj",
  "divider--dashed": "WGjEO",
  "divider--dotted": "XB2dk",
  "divider--small": "jDDQw",
  "divider--medium": "e8hPS",
  "divider--large": "_5at6q",
  "divider--left": "axHA5",
  "divider--center": "JLd8Z",
  "divider--right": "k8-Rr",
  "svgFixerContainer": "mVWLo",
  "emptyChar": "ejwon"
};
export {
  divider_viewer_default as default
};
//# sourceMappingURL=divider-viewer-scss.js.map
